



































import {
  getSubtotalEnabled,
  getSubtotalDiscountIsEmpty,
  getSubtotalDiscount,
  getShowSubtotalTax,
  getSubtotalTaxIsEmpty,
  getSubtotalValue,
  getSubtotalTax,
} from '@getaccept/editor-lib/src/helpers/pricing-table/pricing-table-price-summary.helper';
import type {
  IPricingTableColumn,
  IPricingTableCurrencySettings,
  IPricingTableSummaryValues,
} from '@getaccept/editor-lib';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { PricingTableHelper, EPricingTableColumn } from '@getaccept/editor-lib';

@Component({
  data: () => ({
    PricingTableHelper,
    getSubtotalEnabled,
    getSubtotalDiscountIsEmpty,
    getSubtotalDiscount,
    getShowSubtotalTax,
    getSubtotalTaxIsEmpty,
    getSubtotalValue,
    getSubtotalTax,
  }),
})
export default class PricingTablePriceSummary extends Vue {
  @Prop() sectionSummary: IPricingTableSummaryValues;
  @Prop() currencySettings: IPricingTableCurrencySettings;
  @Prop() isPreCalculated: boolean;
  @Prop() columns: IPricingTableColumn[];

  getShowSubtotalDiscount(): boolean {
    const isSubTotalDiscountEmpty = getSubtotalDiscountIsEmpty(this.sectionSummary);
    if (!PricingTableHelper.getIsColumnEnabled(this.columns, EPricingTableColumn.Discount)) {
      return false;
    }
    if (this.isPreCalculated && !isSubTotalDiscountEmpty) {
      return true;
    }
    return !isSubTotalDiscountEmpty;
  }
}
